<template>
    <div class="portlet light bordered">
        <form class="form-horizontal" @submit.prevent="getServings()">
            <div class="row">
                <div class="col-md-6">
                    <div class="radio-label">Zmiana z</div>
                    <label class="radio-inline">
                      <input type="radio" name="change-from-option" checked @change="setCheckedFrom('portion')">Składnika
                    </label>
                    <label class="radio-inline">
                      <input type="radio" name="change-from-option" @change="setCheckedFrom('component')">Posiłku składowego
                    </label>
                </div>
                <div class="col-md-6">
                    <div class="radio-label">Zmiana na</div>
                    <label class="radio-inline">
                      <input type="radio" name="change-to-option" checked @change="setCheckedTo('portion')">Składnik
                    </label>
                    <label class="radio-inline">
                      <input type="radio" name="change-to-option" @change="setCheckedTo('component')">Posiłek składowy
                    </label>
                </div>
            </div>
            <div class="row">
                <div v-show="checkedFrom === 'portion'" class="col-md-6">
                    <singleselect
                            v-model="fromPortion"
                            name="from-portion"
                            :options="portions"
                            :display-label="false"
                            label="idAndName"
                            :checked="fromPortion"
                    >
                    </singleselect>
                </div>
                <div v-show="checkedFrom === 'component'" class="col-md-6">
                    <singleselect
                            v-model="fromComponent"
                            name="from-component"
                            :options="components"
                            :display-label="false"
                            label="idAndName"
                            :checked="fromComponent"
                    >
                    </singleselect>
                </div>
                <div v-show="checkedTo === 'portion'" class="col-md-6">
                    <singleselect
                            v-model="toPortion"
                            name="to-portion"
                            :options="portions"
                            :display-label="false"
                            label="idAndName"
                            :checked="toPortion"
                    >
                    </singleselect>
                </div>
                <div v-show="checkedTo === 'component'" class="col-md-6">
                    <singleselect
                            v-model="toComponent"
                            name="to-component"
                            :options="components"
                            :display-label="false"
                            label="idAndName"
                            :checked="toComponent"
                    >
                    </singleselect>
                </div>
            </div>
            <div v-show="(fromPortion || fromComponent) && (toPortion || toComponent)" class="row">
                <div class="col-md-6">
                </div>
                <div class="col-md-6">
                    <div class="col-md-10" style="text-align: right !important;">
                        <button class="btn btn-success">Znajdź porcje</button>
                    </div>
                </div>
            </div>
          <div v-show="loading !== 0" class="row">
            <div class="col-sm-12">
              <h2>{{ trans('form.please_wait') }}...</h2>
              <ring-loader></ring-loader>
            </div>
          </div>
            <div v-show="showTable" class="row">
              <div class="col-md-12" style="padding-left: 23px;">
                <input
                    v-model="isCheckAll"
                    type="checkbox"
                    :checked="false"
                    @change="checkAll"
                />
                <b style="padding-left: 8px;">Zaznacz wszystko</b>
              </div>
                <div class="col-md-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>ID porcji</th>
                                <th>Nazwa porcji</th>
                                <th>ID posiłku</th>
                                <th>Nazwa posiłku</th>
                              <th
                                  v-tooltip="{
                                    // eslint-disable-next-line vue/max-len
                                    content:'Liczba Posiłków, które blokują możliwość podmiany składnika/posiłku składowego.<br/>Są to Posiłki zaplanowane w menu na najbliższe 7 dni.',
                                    trigger: 'hover',
                                    placement: 'top',
                                    }"
                              >PK w menu <sup>?</sup></th>
                              <th/>
                            </tr>
                        </thead>
                        <tbody v-for="(serving, index) in servings" :key="index">
                            <tr>
                                <td
                                    v-tooltip="{
                                      content: serving.finalMeals.length > 0 ? 'Posiłek występuje w menu na najbliższe 7 dni.' : null,
                                      trigger: 'hover',
                                      placement: 'top',
                                    }"
                                >
                                  <input
                                      :ref="serving.id"
                                      type="checkbox"
                                      :checked="false"
                                      :disabled="serving.finalMeals.length > 0"
                                  >
                                  <a :href="'/serving/show/' + serving.id">{{ serving.id }}</a>&nbsp;&nbsp;
                                </td>
                                <td>{{ serving.name }}</td>
                                <td><a :href="'/meal/show/' + serving.meal.id">{{ serving.meal.id }}</a></td>
                                <td>{{ serving.meal.name }}</td>
                                <td>{{ serving.finalMeals.length }}</td>
                                <td v-if="serving.finalMeals.length > 0">
                                  <input
                                      v-model="checkedServings[serving.id]"
                                      type="checkbox"
                                      :checked="false"
                                  /><span style="padding-left: 8px;">Rozwiń listę PK</span>
                                </td>
                            </tr>
                            <tr
                                v-for="(finalMeal) in serving.finalMeals"
                                v-show="checkedServings[serving.id]"
                                :key="finalMeal.id"
                            >
                              <td></td>
                              <td colspan="5"><b>{{finalMeal.id}} {{finalMeal.name}}</b></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-12">
                    <div class="col-md-6">
                    </div>
                    <div class="col-md-6">
                        <div class="col-md-10" style="text-align: right !important;">
                            <button type="reset" class="btn btn-light" @click="clearServings()">Anuluj</button>
                            <button
                                v-show="unitMultiplier && ratioMultiplier"
                                type="button"
                                class="btn btn-success"
                                @click="swap"
                            >Podmień</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Singleselect from '../../component/dccore-form/singleselect.vue'
import axios from 'axios'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

export default {
  components: {
    Singleselect,
    RingLoader,
  },
  data() {
    return {
      isCheckAll: false,
      loading: 0,
      checkedServings: [],
      fromPortion: null,
      toPortion: null,
      fromComponent: null,
      toComponent: null,
      portions: [],
      components: [],
      unitMultiplier: '1.00',
      ratioMultiplier: '1.00',
      checkedFrom: 'portion',
      checkedTo: 'portion',
      servings: [],
      showTable: false
    }
  },
  watch: {
    'fromComponent': function() {
      this.clearTable()
      this.compareComponents()
    },
    'toComponent': function() {
      this.clearTable()
      this.compareComponents()
    },
    'fromPortion': function() {
      this.clearTable()
      this.compareComponents()
    },
    'toPortion': function() {
      this.clearTable()
      this.compareComponents()
    },
  },
  created() {
    this.fetchPortions()
    this.fetchComponents()
  },
  methods: {
    async fetchPortions() {
      let url = Routing.generate('api_get_serving_all_portions', {})
      const response = await axios.get(
        url, {}
      )
      this.portions = response.data
    },
    async fetchComponents() {
      let url = Routing.generate('api_get_serving_all_components', {})
      const response = await axios.get(
        url, {}
      )
      this.components = response.data
    },
    setCheckedFrom(value) {
      this.clearTable()
      this.checkedFrom = value
    },
    setCheckedTo(value) {
      this.clearTable()
      this.checkedTo = value
    },
    isAllServingsByMealIsChecked() {
      const checkedServings = this.getCountedServings(this.getCheckedServings())
      const countedServings = this.getCountedServings(this.servings)
      let doubledIds = ''
      Object.entries(checkedServings).forEach(([key, el]) => {
        if (el !== countedServings[key]) {
          doubledIds += `${key.toString()}, `
        }
      })
      return doubledIds
    },
    getCheckedServings() {
      return this.servings.filter((serving) => {
        return Boolean(this.$refs[serving.id][0].checked) === true
      })
    },
    getCountedServings(servings) {
      return servings.map((a) => {
        return { count: 1,
          id: a.meal.id }
      }).reduce((a, b) => {
        a[b.id] = (a[b.id] || 0) + b.count
        return a
      }, {})
    },
    async compareComponents() {
      if (this.fromPortion && this.toComponent && this.checkedFrom === 'portion' && this.checkedTo === 'component') {
        let url = Routing.generate('api_compare_serving_components_from_portion_to_component', { componentId: this.toComponent })
        const response = await axios.get(
          url, {}
        )
        if (!response.data.isMass) {
          window.toastr.error('Wybrany posiłek składowy nie jest podany w masie')
          this.toComponent = null
        }
        if (!response.data.oneServing) {
          window.toastr.error('Wybrany posiłek składowy nie ma dokładnie jednej porcji')
          this.toComponent = null
        }
      }
      if (this.fromComponent && this.toPortion && this.checkedFrom === 'component' && this.checkedTo === 'portion') {
        let url = Routing.generate('api_compare_serving_components_from_component_to_portion', { componentId: this.fromComponent })
        const response = await axios.get(
          url, {}
        )
        if (!response.data.isMass) {
          window.toastr.error('Wybrany posiłek składowy nie jest podany w masie')
          this.fromComponent = null
        }
      }
      if (this.fromComponent && this.toComponent && this.checkedFrom === 'component' && this.checkedTo === 'component') {
        let url = Routing.generate('api_compare_serving_components', { firstId: this.fromComponent,
          secondId: this.toComponent })
        const response = await axios.get(
          url, {}
        )
        if (!response.data.sameUnits) {
          window.toastr.error('Wybrany posiłek składowy podany jest w innej jednostce')
          this.toComponent = null
        }
        if (!response.data.oneServing) {
          window.toastr.error('Wybrany posiłek składowy nie ma dokładnie jednej porcji')
          this.toComponent = null
        }
      }
    },
    async getServings() {
      this.loading++
      let btn = $('.btn')
      btn.button('loading')
      this.showTable = false
      let url = this.checkedFrom === 'portion' ?
        Routing.generate('api_get_serving_portion_servings', { portionId: this.fromPortion }) :
        Routing.generate('api_get_serving_component_servings', { componentId: this.fromComponent })

      const response = await axios.get(
        url, {}
      )
      this.servings = response.data.servings
      this.showTable = true
      btn.button('reset')
      this.loading--
    },
    clearServings() {
      this.isCheckAll = false
      this.checkedServings = []
      this.servings = []
      this.fromComponent = null
      this.toComponent = null
      this.fromPortion = null
      this.toPortion = null
      this.showTable = false
      this.loading = 0
    },
    clearTable() {
      this.showTable = false
      this.loading = 0
      this.isCheckAll = false
      this.checkedServings = []
      this.servings = []
    },
    swap() {
      let doubledMeals = this.isAllServingsByMealIsChecked()
      if (doubledMeals !== '') {
        window.toastr.error(`Nie zostały zaznaczone wszystkie porcje posiłków ${doubledMeals.replace(/,\s*$/, '')}`)
      } else {
        this.showTable = false
        this.loading++
        let btn = $('.btn')
        btn.button('loading')
        let url = Routing.generate('api_swap_serving')
        axios.post(
          url, {
            data: {
              fromPortion: this.fromPortion,
              toPortion: this.toPortion,
              fromComponent: this.fromComponent,
              toComponent: this.toComponent,
              unitMultiplier: this.unitMultiplier,
              ratioMultiplier: this.ratioMultiplier,
              checkedFrom: this.checkedFrom,
              checkedTo: this.checkedTo,
              servingsIds: this.servings.filter((serving) => {
                return Boolean(this.$refs[serving.id][0].checked) === true
              }).map(a => a.id),
              mealsIds: this.getDistinctMealIds()
            }
          }).then(() => {
          // eslint-disable-next-line no-undef
          window.toastr.success('Zamiana zakończona sukcesem')
        }, response => {
          this.handleAjaxError(response)
        }).finally(() => {
          btn.button('reset')
          this.clearTable()
          this.getServings()
        })
      }
    },
    getDistinctMealIds() {
      const ids = []
      this.servings.filter(serving => {
        return Boolean(this.$refs[serving.id][0].checked) === true
      }).forEach((el) => {
        if (ids.indexOf(el.meal.id) < 0) {
          ids.push(el.meal.id)
        }
      })
      return ids
    },
    checkAll () {
      this.servings.forEach((serving) => {
        if (serving.finalMeals.length === 0) {
          this.$refs[serving.id][0].checked = this.isCheckAll
        }
      })
    },
  }
}
</script>

<style scoped>
.col-md-6 {
    margin-bottom: 15px;
}
.col-md-10 {
    padding: 0;
}
.radio-label {
    position: relative;
    padding-top: 7px;
    margin-top: 0;
    margin-bottom: 0;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    font-weight: bold;
}
</style>
